import {
  FilterType,
  buildPerformanceInsightsSummaryDatatableFilter,
  usePerformanceInsightsSummaryDatatable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

const managerFilter = (source: ReturnType<typeof usePerformanceInsightsSummaryDatatable>) => {
  return buildPerformanceInsightsSummaryDatatableFilter(source, {
    title: i18n.t('performance_process.analytics.datatable.filters.manager'),
    path: 'managerId',
    identifier: 'managerIds',
    type: FilterType.Entity,
    default: true,
    categories: [
      {
        kind: 'Employee',
        operation: 'in',
      },
    ],
    onUpdateValue(value) {
      track(trackingEvents.performanceAnalytics.insightsSummaryFilterApplied, {
        type: 'managerIds',
        value,
      })
    },
  })
}

export default managerFilter
